import { ArrowLeft, Lock, Smartphone, Shield, Eye, EyeOff, Package, List, TrendingUp, User, MapPin, Clock } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CourierPrivacySecurity({
  navigateTo
}) {
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const activeSessions = [{
    device: "iPhone 13",
    location: "Baku, Azerbaijan",
    lastLogin: "Today 10:30",
    isCurrent: true
  }, {
    device: "Chrome on Windows",
    location: "Baku, Azerbaijan",
    lastLogin: "Yesterday 14:25",
    isCurrent: false
  }, {
    device: "Samsung Galaxy S21",
    location: "Baku, Azerbaijan",
    lastLogin: "3 days ago",
    isCurrent: false
  }];
  const handleChangePassword = e => {
    e.preventDefault();
    // Mock password change
    alert("Password changed successfully!");
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA- pb-24",
    children: [/*#__PURE__*/_jsx("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-4",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: () => navigateTo("profile"),
          className: "w-10 h-10 bg-white-20 backdrop-blur-sm rounded-xl flex items-center justify-center hover-bg-white-30 transition-colors",
          children: /*#__PURE__*/_jsx(ArrowLeft, {
            className: "w-6 h-6"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "text-2xl font-bold",
            children: "Privacy & Security"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-white-80 text-sm",
            children: "Manage your account security"
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "p-4 space-y-4",
      children: [/*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        className: "bg-white rounded-2xl p-5 shadow-md",
        children: [/*#__PURE__*/_jsxs("h2", {
          className: "font-bold text---000080- mb-4 flex items-center gap-2",
          children: [/*#__PURE__*/_jsx(Lock, {
            className: "w-5 h-5 text-neg-2D58AD-"
          }), "Change Password"]
        }), /*#__PURE__*/_jsxs("form", {
          onSubmit: handleChangePassword,
          className: "space-y-4",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("label", {
              className: "block text-sm font-medium text---000080- mb-2",
              children: "Current Password"
            }), /*#__PURE__*/_jsxs("div", {
              className: "relative",
              children: [/*#__PURE__*/_jsx("input", {
                type: showOldPassword ? "text" : "password",
                value: oldPassword,
                onChange: e => setOldPassword(e.target.value),
                placeholder: "Enter current password",
                className: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-200 focus-outline-none focus-ring-2 focus-ring---2D58AD- text---000080-",
                required: true
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                onClick: () => setShowOldPassword(!showOldPassword),
                className: "absolute right-4 top-1-2 neg-translate-y-1-2 text-neg-708094-",
                children: showOldPassword ? /*#__PURE__*/_jsx(EyeOff, {
                  className: "w-5 h-5"
                }) : /*#__PURE__*/_jsx(Eye, {
                  className: "w-5 h-5"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("label", {
              className: "block text-sm font-medium text---000080- mb-2",
              children: "New Password"
            }), /*#__PURE__*/_jsxs("div", {
              className: "relative",
              children: [/*#__PURE__*/_jsx("input", {
                type: showNewPassword ? "text" : "password",
                value: newPassword,
                onChange: e => setNewPassword(e.target.value),
                placeholder: "Enter new password",
                className: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-200 focus-outline-none focus-ring-2 focus-ring---2D58AD- text---000080-",
                required: true
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                onClick: () => setShowNewPassword(!showNewPassword),
                className: "absolute right-4 top-1-2 neg-translate-y-1-2 text-neg-708094-",
                children: showNewPassword ? /*#__PURE__*/_jsx(EyeOff, {
                  className: "w-5 h-5"
                }) : /*#__PURE__*/_jsx(Eye, {
                  className: "w-5 h-5"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("label", {
              className: "block text-sm font-medium text---000080- mb-2",
              children: "Confirm New Password"
            }), /*#__PURE__*/_jsxs("div", {
              className: "relative",
              children: [/*#__PURE__*/_jsx("input", {
                type: showConfirmPassword ? "text" : "password",
                value: confirmPassword,
                onChange: e => setConfirmPassword(e.target.value),
                placeholder: "Confirm new password",
                className: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-200 focus-outline-none focus-ring-2 focus-ring---2D58AD- text---000080-",
                required: true
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                onClick: () => setShowConfirmPassword(!showConfirmPassword),
                className: "absolute right-4 top-1-2 neg-translate-y-1-2 text-neg-708094-",
                children: showConfirmPassword ? /*#__PURE__*/_jsx(EyeOff, {
                  className: "w-5 h-5"
                }) : /*#__PURE__*/_jsx(Eye, {
                  className: "w-5 h-5"
                })
              })]
            })]
          }), /*#__PURE__*/_jsx("button", {
            type: "submit",
            className: "w-full py-3 bg-neg-2D58AD- text-white rounded-xl font-semibold hover-bg---000080- transition-colors",
            children: "Update Password"
          })]
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.1
        },
        className: "bg-white rounded-2xl p-5 shadow-md",
        children: [/*#__PURE__*/_jsxs("h2", {
          className: "font-bold text---000080- mb-4 flex items-center gap-2",
          children: [/*#__PURE__*/_jsx(Shield, {
            className: "w-5 h-5 text-neg-2D58AD-"
          }), "Two-Factor Authentication"]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center justify-between",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-1",
            children: [/*#__PURE__*/_jsx("p", {
              className: "font-semibold text---000080-",
              children: "Enable 2FA"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm text-neg-708094- mt-1",
              children: "Add an extra layer of security to your account"
            })]
          }), /*#__PURE__*/_jsx("button", {
            onClick: () => setTwoFactorEnabled(!twoFactorEnabled),
            className: `relative w-14 h-8 rounded-full transition-colors ${twoFactorEnabled ? "bg-neg-10B981-" : "bg-gray-300"}`,
            children: /*#__PURE__*/_jsx("div", {
              className: `absolute top-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform ${twoFactorEnabled ? "translate-x-7" : "translate-x-1"}`
            })
          })]
        }), twoFactorEnabled && /*#__PURE__*/_jsx("div", {
          className: "mt-4 p-4 bg-neg-10B981--10 border border---10B981--20 rounded-xl",
          children: /*#__PURE__*/_jsx("p", {
            className: "text-sm text---059669- font-medium",
            children: "\u2713 Two-factor authentication is enabled"
          })
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.2
        },
        className: "bg-white rounded-2xl p-5 shadow-md",
        children: [/*#__PURE__*/_jsxs("h2", {
          className: "font-bold text---000080- mb-4 flex items-center gap-2",
          children: [/*#__PURE__*/_jsx(Smartphone, {
            className: "w-5 h-5 text-neg-2D58AD-"
          }), "Active Sessions"]
        }), /*#__PURE__*/_jsx("div", {
          className: "space-y-3",
          children: activeSessions.map((session, index) => /*#__PURE__*/_jsx("div", {
            className: `p-4 rounded-xl border ${session.isCurrent ? "bg-neg-2D58AD--10 border-neg-2D58AD-" : "bg-gray-50 border-gray-200"}`,
            children: /*#__PURE__*/_jsxs("div", {
              className: "flex items-start justify-between mb-2",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex-1",
                children: [/*#__PURE__*/_jsxs("p", {
                  className: "font-semibold text---000080- flex items-center gap-2",
                  children: [session.device, session.isCurrent && /*#__PURE__*/_jsx("span", {
                    className: "px-2 py-0-5 bg-neg-10B981- text-white text-xs rounded-full",
                    children: "Active"
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-1 text-sm text-neg-708094- mt-1",
                  children: [/*#__PURE__*/_jsx(MapPin, {
                    className: "w-3-5 h-3-5"
                  }), /*#__PURE__*/_jsx("span", {
                    children: session.location
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex items-center gap-1 text-sm text-neg-708094- mt-1",
                  children: [/*#__PURE__*/_jsx(Clock, {
                    className: "w-3-5 h-3-5"
                  }), /*#__PURE__*/_jsxs("span", {
                    children: ["Last login: ", session.lastLogin]
                  })]
                })]
              }), !session.isCurrent && /*#__PURE__*/_jsx("button", {
                className: "text-sm text-red-600 hover-underline font-medium",
                children: "Revoke"
              })]
            })
          }, index))
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-around max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("dashboard"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(Package, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Home"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("packages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(List, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Packages"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("performance"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(TrendingUp, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Performance"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("profile"),
          className: "flex flex-col items-center gap-1 text-neg-2D58AD-",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Profile"
          })]
        })]
      })
    })]
  });
}